import { useMutation } from "@tanstack/react-query";
import { deactivateSevenRooms } from "../../api/bSevenroomsApi";

export const useDeactivateSevenRooms = () => {
  return useMutation({
    mutationKey: ["deactivate-sevenrooms"],
    mutationFn: (data) => deactivateSevenRooms(data),
    onError: (error) => {
      console.error("SevenRooms deactivation error:", error.response || error);
    },
  });
};
